<template>
  <div v-scroll="scrolling" class="mt-3">
    <v-layout row>
      <v-flex xs12 md6>
        <div style="padding-bottom: 64px;">
          <v-layout row>
            <v-flex xs4 class="body-2 col">
              {{$t('resources.history.date')}}
            </v-flex>
            <v-flex xs5 class="body-2 col">
             {{$t('resources.history.resource')}}
            </v-flex>
            <v-flex xs3 class="body-2 col">
              {{$t('resources.history.usage')}}
            </v-flex>
          </v-layout>
          <resource-row v-for="row in studentHistory" :key="row.id" :data="row"></resource-row>
          <div :style="{ backgroundColor: noStudentsColor}" class="no-data"
               v-if="studentHistory.length === 0 && !loadingHistory">
            <span :style="{color: getTextColor(noStudentsColor)}">{{$t('resources.history.no_data')}}</span>
          </div>
        </div>
      </v-flex>
   </v-layout>
  </div>
</template>

<script>
import ResourceRow from './ResourceRow'
import { mapActions, mapState } from 'vuex'
import Colors from '../../mixins/Colors'
import { GET_STUDENT_RESOURCE_HISTORY, GET_STUDENT_RESOURCE_HISTORY_NEXT } from '../../store/action-types'

export default {
  name: 'resources-list',
  props: ['active', 'dateRange', 'studentId'],
  mixins: [Colors],
  data () {
    return {
      initiallyLoaded: false,
      noStudentsColor: this.$vuetify.theme.info
    }
  },
  methods: {
    ...mapActions({
      loadHistory: GET_STUDENT_RESOURCE_HISTORY,
      loadHistoryNext: GET_STUDENT_RESOURCE_HISTORY_NEXT
    }),
    scrolling (event) {
      if (this.active && !this.loadingHistory && !this.allHistoryLoaded) {
        const scrollTop = window.scrollY
        const totalScroll = document.body.scrollHeight
        const clientHeight = window.innerHeight
        const leftToScroll = totalScroll - clientHeight - scrollTop
        if (leftToScroll < 300) {
          this.loadHistoryNext(this.studentId)
        }
      }
    },
    load () {
      this.initiallyLoaded = true
      this.loadHistory(this.studentId)
    }
  },
  watch: {
    dateRange (value) {
      this.load()
    },
    active (value) {
      if (value && !this.initiallyLoaded) {
        this.load()
      }
    }
  },
  computed: {
    ...mapState({
      studentHistory: state => state.resources.history,
      loadingHistory: state => state.resources.loadingHistory,
      allHistoryLoaded: state => state.resources.allHistoryLoaded
    })
  },
  mounted () {
    if (this.active) {
      this.load()
    }
  },
  components: {
    ResourceRow
  }
}
</script>

<style>
.col {
  padding: 6px 4px 6px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesList.vue